import { render, staticRenderFns } from "./PreviewSection.vue?vue&type=template&id=0c1843c9&scoped=true&"
import script from "./PreviewSection.vue?vue&type=script&lang=js&"
export * from "./PreviewSection.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSection.vue?vue&type=style&index=0&id=0c1843c9&lang=scss&scoped=true&"
import style1 from "./PreviewSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1843c9",
  null
  
)

export default component.exports